module.exports = __webpack_public_path__ + "static/media/dlv.67b2d2c7.svg";